import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useTags } from '../../../hooks/WPHooks';
import { useLogger } from '../../../services/LogService';
import { SearchableTag } from '../../forms/SearchableTag';
import { ParametersProps } from '../../wizard/WizardSteps';

export interface TagParametersParameters extends ParametersProps {
  onProfilEditPage?: boolean;
}

export const TagParameters: React.FC<TagParametersParameters> = ({
  user,
  updateParameter,
  parameters,
  isSetLoading,
  onProfilEditPage,
}) => {
  const logger = useLogger('TagParameters');

  const { tags: disciplines } = useTags('discipline');
  const { tags: studyYears } = useTags('study_year');
  const { tags: establishments } = useTags('establishment');

  const onChangeTags = (name: string, value: number | undefined) => {
    if (typeof value === 'number') {
      updateParameter(name, value);
    }
  };

  useEffect(() => {
    if (
      disciplines.length > 0 &&
      studyYears.length > 0 &&
      establishments.length > 0
    ) {
      logger.info(
        `useEffect(disciplines, studyYears, establishments) parameters`,
        parameters
      );
      isSetLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disciplines, studyYears, establishments]);

  return (
    <div className="w-full flex flex-col space-y-4">
      {establishments.length > 0 ? (
        <SearchableTag
          options={establishments}
          label={'Establishment'}
          name={'establishment'}
          user={user}
          onChange={onChangeTags}
          value={parameters.establishment}
          borderStyle={
            onProfilEditPage ? 'rounded-xl border-opacity-40' : 'rounded-2xl'
          }
        />
      ) : (
        <p className="text-center w-full text-primary font-bold">
          <FormattedMessage id="Loading" />
        </p>
      )}
      {disciplines.length > 0 ? (
        <SearchableTag
          options={disciplines}
          label={'Discipline'}
          name={'discipline'}
          user={user}
          onChange={onChangeTags}
          value={parameters.discipline}
          borderStyle={
            onProfilEditPage ? 'rounded-xl border-opacity-40' : 'rounded-2xl'
          }
        />
      ) : (
        <p className="text-center w-full text-primary font-bold">
          <FormattedMessage id="Loading" />
        </p>
      )}
      {studyYears.length > 0 ? (
        <SearchableTag
          options={studyYears}
          label={'Study Year'}
          name={'studyYear'}
          user={user}
          onChange={onChangeTags}
          value={parameters.studyYear}
          borderStyle={
            onProfilEditPage ? 'rounded-xl border-opacity-40' : 'rounded-2xl'
          }
        />
      ) : (
        <p className="text-center w-full text-primary font-bold">
          <FormattedMessage id="Loading" />
        </p>
      )}
    </div>
  );
};
